export default "__VITE_PUBLIC_ASSET__1b68609c__"